import React from 'react';
import { DropDown } from './common';
import { connect } from 'react-redux';
import {validatable} from 'components/utils';
import { DuLieuHeThong } from 'api';

class DropDownChonKetQuaGiaiQuyet extends React.Component {
  constructor(props, context) {
    super(props);
    this.state = {
      data: this.props.data
    }
  }

  componentDidMount() {
    if(this.props.data.length == 0) {
      DuLieuHeThong.actions.getKetQuaGiaiQuyetLanHai.request().then(res => {
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: [{
            key: 'ketQuaGiaiQuyetLanHai',
            data: res.data || []
          }]
        })
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data != this.props.data) {
      this.state.data = nextProps.data;
      this.setState({...this.state})
    }
  }

  onChange(e) {
    this.props.onChange(e);
  }

  render() {
    return (
      <DropDown label={this.props.label} isValid={this.props.isValid} bindValidator={this} channel="formTaoDon" selectedValue={this.props.selectedValue} require={this.props.require} options={this.state.data} keyName='giaTri' valueName='ten' onChange={this.onChange.bind(this)} placeholder={this.props.placeholder} className={'col-input '+this.props.className} />
    )
  }
}

DropDownChonKetQuaGiaiQuyet.defaultProps = {
  className: 'input-group',
  onChange: function () {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  label: 'Kết quả giải quyết',
  isValid: false,
  require: false,
  data: []
}

let bindStateToProps = state => {
  return {
    data: state.duLieuHeThong.ketQuaGiaiQuyetLanHai
  }
}

export default connect(bindStateToProps)(validatable(DropDownChonKetQuaGiaiQuyet));



// WEBPACK FOOTER //
// ./src/components/tt-forms/dropdown-chonketquagiaiquyet.jsx